var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServerLocationDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10350_55633)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3367 26.0007H24.8367C25.8565 26.0024 26.8624 25.7642 27.7731 25.3052C28.6838 24.8463 29.4737 24.1794 30.079 23.3587C30.6843 22.538 31.088 21.5863 31.2574 20.5807C31.4268 19.5751 31.3573 18.5437 31.0544 17.5699C30.7514 16.5961 30.2236 15.7073 29.5136 14.9753C28.8036 14.2432 27.9313 13.6885 26.9673 13.356C26.0032 13.0235 24.9744 12.9224 23.9641 13.0611C22.9538 13.1997 21.9902 13.5741 21.1514 14.154C20.8166 12.3713 20.0031 10.7133 18.7983 9.35739C17.5934 8.00152 16.0424 6.99889 14.3114 6.45688C12.5804 5.91487 10.7345 5.85389 8.97153 6.28046C7.20853 6.70703 5.59475 7.60509 4.30299 8.87848C3.01123 10.1519 2.09015 11.7526 1.63838 13.5093C1.1866 15.2661 1.22115 17.1126 1.73831 18.8512C2.25548 20.5897 3.23579 22.1549 4.57427 23.3791C5.91275 24.6033 7.55899 25.4404 9.33672 25.8007",
    stroke: "#3C4D6A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10350_55633"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.323242)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServerLocationDesktop);
export default __webpack_public_path__ + "static/media/server_location_desktop.37754980074f853828099bffe1de6888.svg";
export { ForwardRef as ReactComponent };